var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-membership"},[_c('error',{attrs:{"errors":_vm.membershipError}}),_c('membership-form',{attrs:{"action":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }